export default __webpack_public_path__ + "static/media/eMed-heart.5507cee8.png";